import AssetViewPage from '../asset/AssetViewPage'
import { AssetSourceView } from '../asset/AssetSourceView'
import { KindViewPageProps } from '../KindPages'

const ConfigurationViewPage = (props: KindViewPageProps) => (
  <AssetViewPage
    {...props}
    renderSource={({ content, isLoading }) => (
      <AssetSourceView content={content} isLoading={isLoading} defaultLanguage="yaml" />
    )}
  />
)

export default ConfigurationViewPage
